<template>
	<div class="wrapper">
		<div class="bgc">
			<div class="shop-container">
				<div class="nav-bread">
					<router-link to="/">首页</router-link>
					<span>></span>
					<span>商品详情</span>
				</div>
			</div>
		</div>
		<div class="main bgw">
			<div class="shop-container" v-loading="loadingShow">
				<div class="t">
					<div class="tl">
						<div class="tl-img-box">
							<img class="play-acution" src="@/assets/images/play-circle.png" alt="" @click="playYoutube"  v-if="goodsInfo.video_id && goodsInfo.video_id != ''"/>

							<div class="youtube-player" v-show="videoShow"  v-if="goodsInfo.video_id && goodsInfo.video_id != ''">
								<video-player
									style="width: 100%; height: 100%"
									class="video-player vjs-custom-skin"
									ref="videoPlayer"
									:playsinline="true"
									:options="playerOptions"
								></video-player>
							</div>
							<vue-magnify :previewImg="currentImg" :zoomImg="currentImg"></vue-magnify>
						</div>
						<div class="tl-tabs">
							<div class="prev" @click="scrollPrev" :class="{ disabled: currentPicImg == 0 }"><i class="icon iconfont iconprev"></i></div>
							<div class="next" v-if="productImgList && productImgList.length" 
							@click="scrollNext" :class="{ disabled: currentPicImg ==  productImgList.length - 1 }">
							<i class="icon iconfont iconnext"></i></div>
							<div class="img-list-box">
								<ul class="img-tabs" :style="{ width: ulWidth, left: ulLeft + 'px' }">
									<li v-for="(img, index) in productImgList" :key="index" :class="{active: currentPicImg == index}"
									 @click="changeShowImg(img, index)"><img v-lazy="img" alt :key="img" /></li>
								</ul>
							</div>
						</div>
					</div>
					<div class="tr">
						<div class="tr-title">{{ goodsInfo.name }}</div>
						<div class="tr-desc">{{ goodsInfo.brief }}</div>
						<div class="tr-price tr-group">
							<div class="tr-title-left">一口价</div>
							<div class="tr-right">
								<span class="now-price">
									<i>￥</i>
									<span class="price-num">{{ goodsInfo.price }}</span>
								</span>
								<!-- <span class="old-price">
									<del>￥{{ goodsInfo.mktprice }}</del>
								</span> -->
							</div>
						</div>
						<div class="tr-group underline" v-if="product.promotion_list && product.promotion_list.length > 0">
							<div class="tr-title-left">促销</div>
							<div class="tr-right">
								<span class="cx-item" v-for="(item, index) in product.promotion_list" :key="index">{{ item.name }}</span>
							</div>
						</div>
						<!-- <div class="tr-group">
              <div class="tr-title-left">重量</div>
              <div class="tr-right">
                <span class="weight">1.65Kg</span>
              </div>
            </div>-->
						<template v-if="product.default_spes_desc">
							<div class="tr-group" v-for="(value, key, i) in product.default_spes_desc" :key="i">
								<div class="tr-title-left">{{ key }}</div>
								<div class="tr-right">
									<div class="color" v-for="(item, index) in value" :key="index" :class="{ active: item.is_default }" @click="changeSpes(item.product_id)">
										<a href="javascript:;">{{ item.name }}</a>
									</div>
								</div>
							</div>
						</template>

						<div class="tr-group">
							<div class="tr-title-left">数量</div>
							<div class="tr-right">
								<el-input-number v-model="buyNum" @change="handleChange" :min="1" label="购买数量" size="small" :max="buyMax"></el-input-number>
								<div class="kc">库存{{ product.stock }}件</div>
							</div>
						</div>
						<div class="tr-foot">
							<div class="btn add-btn" v-if="goodsInfo.marketable == 1" @click="addToCart" v-show="goodsInfo.is_nomal_virtual != 2">加入购物车</div>
							<div class="btn buy-btn" v-if="goodsInfo.marketable == 1" @click="buyNow">立刻购买</div>

							<div class="btn sold-out" v-if="goodsInfo.marketable == 2">已下架</div>

							<div class="collete-btn" @click="changeFav" v-if="goodsInfo.marketable == 1" :title="isFav ? '取消收藏' : '添加收藏'">
								<i class="icon iconfont iconshoucang" v-if="isFav"></i>
								<i class="icon iconfont iconshoucang01" v-else></i>
								<div>{{ isFav ? '已收藏' : '收藏' }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="b" style="position:relative">
					<div class="tabs">
						<div class="tab" v-for="(item, index) in tabTitleArr" :key="index" @click="returnTo(item.id)" :class="{ active: tabIndex == index }">{{ item.name }}</div>
					</div>
					<div style="overflow: hidden;">
						<div class="leaderboard">
							<div class="title">热门推荐</div>

							<div class="board">
								<div class="item" v-for="(item, index) in saleRanking" :key="index" @click="toDetails(item.id)">
									<div class="img"><img v-lazy="item.cover_img" alt="" /></div>
									<div class="info">
										<div class="name">{{ item.name }}</div>
										<div class="price">
											<span class="txt">当前价</span>
											￥{{ item.current_auction_price }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="shop-info-wrap" style="width:75%;float:left">
							<div id="detail">
								<!-- <div v-if="goodsParams" class="params-wrap">
                  <h3>
                      <img class="sign" src="~@/assets/images/sign.png" alt="" />
                      商品参数
                      <img class="sign sign2" src="~@/assets/images/sign.png" alt="" />
                    </h3>
                  <div v-for="(item,index) in goodsParams" :key="index" class="params-content" v-if="item.value">{{item.name}}：{{item.value}}</div>
                </div> -->
								<div class="shop-info-item" v-show="tabIndex == 0" v-html="goodsInfo.intro"></div>
							</div>

							<div class="params-wrap">
								<h3>
									<img class="sign" src="~@/assets/images/sign.png" alt="" />
									评论区
									<img class="sign sign2" src="~@/assets/images/sign.png" alt="" />
								</h3>
							</div>

							<msg-list :relId="goodsId" type="1" v-if="goodsId != ''" />

							<div class="shop-info-item" id="comment">
								<!-- <h3>晒单评价</h3>
                <div v-if="goodsComments.count==0">
                  <div class="no-comment">暂无评价</div>
                </div> -->
								<!-- <div v-for="(item,index) in goodsComments.list" :key="index" class="comment" v-else>
                  <div class="user">
                    <div class="user-head">
                      <img v-lazy="item.user.avatar" alt>
                    </div>
                    <span class="user-name">{{item.user.nickname}}</span>
                  </div>
                  <div class="detail">
                    <div class="score">
                      <el-rate v-model="item.score" disabled></el-rate>
                    </div>
                    <div class="content">{{item.content}}</div>
                    <div v-if="item.images_url" class="img-list">
                      <div v-for="(img,i) in item.images_url" :key="i" class="img-li" @click="changeBigImg(img,i,index,item)" :class="{'active':img==item.currentImg}">
                        <img v-lazy="img" alt>
                      </div>
                    </div>
                    <transition name="img-zoom">
                      <div v-show="item.showBigImg" class="big-img" :class="{'hidden':!item.showBigImg}">
                        <img v-lazy="item.currentImg" alt>
                      </div>
                    </transition>

                    <div class="time">
                      <span class="addon" v-if="item.addon">{{item.addon}}</span>
                      {{item.ctime}}
                    </div>
                  </div>
                </div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<transition name="el-fade-in">
			<div class="scrollTop" v-show="toTopShow" @click="scrollToTop">
				<i class="icon iconfont iconfanhuidingbu"></i>
				<p>顶部</p>
			</div>
		</transition>

		<!-- <msg :relId="goodsId" type="1" v-if="goodsId"/> -->
	</div>
</template>

<script>
import vueMagnify from '@/components/vue-magnify/index.vue';
import { timeToDate, isSafeRedirect } from '@/utils';
import { mapActions } from 'vuex';
// import Msg from '../components/msg.vue';
import MsgList from '@/components/msg/MsgList.vue';

export default {
	name: 'ProductDetail',
	components: { vueMagnify, MsgList },
	props: {},
	data() {
		return {
			playerOptions: {
				playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				autoplay: false, //如果true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 导致视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						// type: "application/x-mpegURL",
						// video/mp4
						//src: 'https://s3plus.sankuai.com/yangguangyimai-prod/static/uploads/video/2021/12/16/163964486961bafec60fab2.mp4'//url地址
						src: '' //url地址
					}
				],
				poster: '', //你的封面地址
				// notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
					fullscreenToggle: true //全屏按钮
				}
			},
			toTopShow: false,
			buyNum: 1,
			tabTitleArr: [
				{
					id: 'detail',
					name: '商品详情'
				},
				{
					id: 'comment',
					name: '评论'
				}
			],
			tabIndex: 0,
			goodsId: '',
			imgList: [],
			ulLeft: 0,
			isEnd: false,
			goodsInfo: {}, //商品详情
			product: {}, // 规格详情
			isFav: false, //收藏
			goodsParams: null, //商品参数信息
			goodsComments: {
				count: 0,
				page: 1,
				limit: 15,
				list: null
			}, // 商品评论信息, //商品评论信息
			currentImg: '', //列表选中图片
			selectCommentImg: '', //评论选中图片
			selectCommentImgIndex: null, //评论选中图片
			selectCommentIndex: null, //评论选中图片
			loadingShow: false,
			saleRanking: [], //销量排行榜
			videoShow: false,
			currentPicImg: 0
		};
	},
	watch: {
		$route(to, from) {
			if (to.name == 'detail') {
				let goodsId = this.$route.params.goodsId;
				if (goodsId) {
					this.goodsId = goodsId;
					this.getAllInfo();
				}
			}
			if (this.$route) {
				this.buyNum = 1;
			}
		}
	},
	computed: {
		ulWidth() {
			if (this.goodsInfo.album) {
				return this.goodsInfo.album.length * 62 + 'px';
			}
			return 0 + 'px';
		},
		prevDisabled() {
			return this.ulLeft == 0;
		},
		nextDisabled() {
			if (this.goodsInfo.album) {
				return this.goodsInfo.album.length <= 5 || this.isEnd;
			}
			return false;
		},
		buyMax() {
			return this.product.stock;
		},
		productImgList() {
			return this.goodsInfo.album;
		}
	},
	methods: {
		...mapActions(['getCartNumsAction']),
		playYoutube() {
			this.videoShow = true;
			this.$nextTick(() => {
				this.$refs.videoPlayer.player.play();
			});
		},
		handleChange(value) {},
		scrollPrev() {
			// this.ulLeft = 0;

			if(this.currentPicImg == 0) {
				return
			}
			this.currentPicImg --
			this.currentImg = this.productImgList[this.currentPicImg]

			if(this.productImgList.length - 4 <= this.currentPicImg) {
				return
			} 


			let num = this.currentPicImg
			this.ulLeft = -60 * num
		},
		scrollNext() {

			if(this.productImgList.length - 1 == this.currentPicImg) {
				return
			}
			this.currentPicImg ++
			this.currentImg = this.productImgList[this.currentPicImg]

			if(this.productImgList.length - 4 <= this.currentPicImg) {
				return
			} 
			let num = this.currentPicImg


			if(this.productImgList.length <= 5) {
				return
			}
			this.ulLeft = -60 * num


			// let num = this.productImgList.length - 5;
			// let left = 54 * num + 24;
			// this.ulLeft = -left;
			// this.isEnd = true;
		},
		addToCart() {
			let data = {
				product_id: this.product.id,
				nums: this.buyNum
			};
			this.$api.addCart(data).then(res => {
				if (res.status) {
					this.getCartNums();
					this.$router.push({
						path: '/buySuccess',
						query: { goodsName: this.goodsInfo.name }
					});
				} else {
					this.$message({
						message: res.msg,
						type: 'error'
					});
				}
			});
		},
		buyNow() {
			let data = {
				product_id: this.product.id,
				nums: this.buyNum,
				type: 2 // 区分加入购物车和购买
			};
			this.$api.addCart(data).then(res => {
				if (res.status) {
					let cartIds = res.data;
					this.$router.push({
						name: 'order',
						query: { cart_ids: JSON.stringify(cartIds) }
					});
				} else {
					this.$message({
						message: res.msg,
						type: 'error'
					});
				}
			});
		},
		// 获取购物车数量
		getCartNums() {
			this.$api.getCartNum().then(res => {
				if (res.status) {
					this.getCartNumsAction(res.data);
				}
			});
		},
		//切换评论图片大图
		changeBigImg(img, i, index, item) {
			if (img == item['currentImg']) {
				this.$set(item, 'showBigImg', false);
				this.$set(item, 'currentImg', '');
			} else {
				this.$set(item, 'showBigImg', true);
				this.$set(item, 'currentImg', img);
			}
			// if (this.selectCommentIndex == index) {
			// } else {
			//   this.selectCommentImg = img;
			//   this.selectCommentImgIndex = i;
			// }

			this.selectCommentIndex = index;
		},
		//切换显示图片
		changeShowImg(img, idx) {

			this.currentPicImg = idx
			if(this.productImgList.length > 5) {

				if(idx >= this.productImgList.length - 5) {
					this.ulLeft = -60 * (this.productImgList.length - 5) 
				}
			}
			this.currentImg = img;
			this.videoShow = false;

			setTimeout(() => {
				this.$refs.videoPlayer && this.$refs.videoPlayer.player.pause();
			}, 200);
		},
		returnTo(id) {
			// document.getElementById(id).scrollIntoView({behavior: "smooth"})
			document.getElementById(id).scrollIntoView();
		},
		//获取商品参数
		getGoodsParams() {
			let data = { id: this.goodsId };
			this.$api.goodsParams(data).then(res => {
				if (res.status) {
					this.goodsParams = res.data;
				}
			});
		},
		getGoodsComments() {
			let data = {
				page: this.goodsComments.page,
				limit: this.goodsComments.limit,
				goods_id: this.goodsId
			};
			this.$api.goodsComment(data).then(res => {
				if (res.status) {
					let _list = res.data.list;
					_list.forEach(item => {
						item.ctime = timeToDate(item.ctime);
						this.$set(item, 'showBigImg', false);
						this.$set(item, 'currentImg', '');
					});
					this.goodsComments.list = _list;
					this.goodsComments.count = res.data.count;
				}
			});
		},
		//商品详情
		getGoodsDetail() {
			let data = {
				id: this.goodsId
			};
			let userToken = this.$storage.get('userToken');
			if (userToken) {
				data['token'] = userToken;
			}
			this.loadingShow = true;
			this.$api.goodsDetail(data).then(res => {
				if (res.status == true) {
					this.loadingShow = false;
					let info = res.data;
					this.goodsInfo = info;
					if (this.goodsInfo.video_id != '') {
						this.playerOptions.sources[0].src = this.goodsInfo.video.video_url;
						this.playerOptions.poster = this.goodsInfo.video.video_cover;
					}
					this.product = res.data.product;
					this.isFav = info.isfav === 'true' ? true : false;
					this.currentImg = this.goodsInfo.album[0];
					if (this.$storage.get('userToken')) {
						this.goodsBrowsing();
					}
				}
			});
		},
		goodsBrowsing() {
			let data = {
				goods_id: this.goodsInfo.id
			};
			this.$api.addGoodsBrowsing(data).then();
		},
		//切换商品规格
		changeSpes(id) {
			this.$api.getProductInfo({ id }).then(res => {
				if (res.status) {
					this.product = res.data;
				}
			});
		},
		//切换收藏
		changeFav() {
			let data = {
				goods_id: this.goodsInfo.id
			};
			this.$api.goodsCollection(data).then(res => {
				if (res.status) {
					this.isFav = !this.isFav;
				}
			});
		},
		getAllInfo() {
			this.getGoodsDetail();
			this.getGoodsParams();
			this.getGoodsComments();
		},
		handleScroll() {
			this.scrollTop = this.scrollTop = window.pageYOffset || document.body.scrollTop;
			if (this.scrollTop > 500) {
				this.toTopShow = true;
			} else {
				this.toTopShow = false;
			}
		},
		scrollToTop() {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		// 获取销量排行榜
		getSalesRanking() {
			this.$api.auctionList({ is_rec: 1 }).then(res => {
				if (res.status) {
					this.saleRanking = res.data.list.splice(0, 6);
				}
			});
		},
		toDetails(id) {
			let { href } =  this.$router.resolve({
				name: 'auction',
				params: { goodsId: id }
			});
			if (!isSafeRedirect(href)) {
				console.warn('非白名单域名，禁止跳转:', href);
				return;
			}
			window.open(href, '_blank')

			// this.$router.push({
			//   name: 'detail',
			//   params: { goodsId: id },
			// })
		}
	},
	created() {},
	mounted() {
		this.$api.addRecord({ type: '2', api_method: 'goods.getdetial', rel_id: this.$route.params.goodsId, platform: '1' });

		let goodsId = this.$route.params.goodsId;
		this.goodsId = goodsId;
		this.getAllInfo();
		this.$nextTick(function() {
			window.addEventListener('scroll', this.handleScroll);
		});
		// 获取销量排行榜
		this.getSalesRanking();
	}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.img-zoom-enter-active,
.img-zoom-leave-active {
	width: 100%;
	transition: all 0.2s linear;
}
.img-zoom-enter,
.img-zoom-leave-to {
	width: 0;
	opacity: 0;
}
.scrollTop {
	position: fixed;
	right: 30px;
	bottom: 30px;
	width: 60px;
	height: 60px;
	border-radius: 50%;
	background: $theme-color;
	text-align: center;
	color: #fff;
	z-index: 999;
	cursor: pointer;
	.icon {
		display: block;
		margin-top: 12px;
		margin-bottom: 5px;
	}
	p {
		font-size: 12px;
	}
}
.comment {
	display: flex;
	border-bottom: 1px solid $border;
	padding: 15px 0;
	.user {
		display: inline-flex;
		.user-head {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			margin-right: 10px;
			overflow: hidden;
			img {
				display: block;
				width: 40px;
				height: 40px;
				object-fit: cover;
			}
		}
		.user-name {
			display: inline-block;
			color: #757575;
			font-size: 12px;
			width: 75px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
	.detail {
		flex: 1;
		.content {
			padding: 10px 0;
		}
		.img-list {
			margin: 10px 0;
			display: inline-flex;
			.img-li {
				width: 52px;
				height: 52px;
				margin-right: 10px;
				margin-bottom: 5px;
				border: 1px solid $border;
				padding: 2px;
				&.active {
					padding: 1px;
					border: 2px solid $theme-color;
				}
				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}
		}
		.big-img {
			max-width: 300px;
			border: 1px solid $border;
			padding: 2px;
			&.hidden {
				border: none;
				padding: 0;
			}
			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: contain;
			}
		}
		.time {
			color: #999;
			font-size: 12px;
			margin-top: 10px;
			.addon {
				margin-right: 20px;
			}
		}
	}
}

.wrapper {
	.main {
		padding-top: 14px;
		.t {
			display: flex;
			padding-bottom: 30px;
			.tl {
				margin-right: 20px;
				.tl-img-box {
					width: 350px;
					height: 350px;
					border: 1px solid $border;
					margin-bottom: 20px;
					position: relative;
					.play-acution {
						position: absolute;
						left: 10px;
						bottom: 10px;
						width: 40px;
						height: 40px;
						z-index: 9;
					}
					.youtube-player {
						position: absolute;
						left: 0;
						top: 0;
						width: 350px;
						height: 350px;
						z-index: 9;
					}
					img {
						width: 100%;
						height: 100%;
						object-fit: contain;
					}
				}
				.tl-tabs {
					height: 54px;
					position: relative;
					.img-list-box {
						width: 310px;
						height: 54px;
						margin: 0 auto;
						position: relative;
						overflow: hidden;
						padding-bottom: 4px;
						ul {
							position: absolute;
							left: 0;
							top: 0;
							height: 54px;
							transition: left 0.15s linear;
							li {
								width: 60px;
								height: 54px;
								float: left;
								display: flex;
								align-items: center;
								// margin: 0 4px;
								border: 1px solid $border;
								padding: 1px;
								box-sizing: border-box;
								&.active {
									border: 2px solid $theme-color;
									padding: 0;
								}
								&:hover {
									border: 2px solid $theme-color;
									padding: 0;
								}
								img {
									// width: 100%;
									// height: 100%;

									width: 54px;
									height: 54px;

									object-fit: cover;
								}
							}
						}
					}
					.prev {
						position: absolute;
						left: -5px;
						top: 50%;
						width: 26px;
						height: 26px;
						margin-top: -16px;
						cursor: pointer;
						&.disabled {
							cursor: not-allowed;
							.icon {
								color: $border;
							}
						}
						.icon {
							font-size: 26px;
							color: #757575;
						}
					}
					.next {
						position: absolute;
						right: -5px;
						top: 50%;
						width: 26px;
						height: 26px;
						margin-top: -16px;
						cursor: pointer;
						&.disabled {
							cursor: not-allowed;
							.icon {
								color: $border;
							}
						}
						.icon {
							font-size: 26px;
							color: #757575;
						}
					}
				}
			}
			.tr {
				flex: 1;
				position: relative;
				.tr-title {
					font-weight: 700;
					color: #666;
					padding-top: 10px;
					line-height: 28px;
					font-size: 18px;
					margin-bottom: 5px;
				}
				.tr-desc {
					font-size: 14px;
					margin-bottom: 20px;
					line-height: 20px;
				}
				.tr-group {
					margin-bottom: 15px;
					position: relative;
					display: flex;
					&.underline {
						padding-bottom: 10px;
						border-bottom: 1px solid $border;
					}
					.tr-title-left {
						color: #838383;
						font-size: 12px;
						display: inline-block;
						width: 60px;
						height: 32px;
						line-height: 32px;
					}
					.tr-right {
						display: inline-block;
						flex: 1;
						.now-price {
							color: $theme-color;
							text-align: left;
							margin-right: 20px;
							i {
								font-size: 16px;
							}
							.price-num {
								font-size: 22px;
							}
						}
						.old-price {
							color: #666;
							font-size: 12px;
						}
						.cx-item {
							padding: 2px 4px;
							background: $theme-color;
							color: #fff;
							margin-right: 10px;
							font-size: 12px;
							height: 24px;
							line-height: 24px;
						}
						.color,
						.size {
							font-size: 12px;
							border: 1px solid #b8b7bd;
							margin-right: 8px;
							display: inline-block;
							height: 28px;
							line-height: 28px;
							margin-bottom: 12px;
							&.active {
								border-color: $theme-color;
								background: $theme-color;
								color: #fff;
							}
							a {
								display: block;
								padding: 0 10px;
							}
							&:hover {
								border: 1px solid $theme-color;
							}
						}
						.weight {
							font-size: 12px;
						}
						.kc {
							color: #878787;
							display: inline-block;
							font-size: 12px;
							margin-left: 20px;
						}
					}
				}
			}
		}
	}
}
.tr-foot {
	display: flex;
	position: absolute;
	bottom: 0;
	.btn {
		height: 45px;
		line-height: 45px;
		font-size: 14px;
		width: 180px;
		text-align: center;
		border: 1px solid $theme-color;
		margin-right: 20px;
		cursor: pointer;
		&.add-btn {
			color: #ffc300;
			border-color: #ffc300;
		}
		&.buy-btn {
			background: #ffc300;
			color: #fff;
			border-color: #ffc300;
		}
		&.sold-out {
			background: $theme-color;
			color: #fff;
			cursor: not-allowed;
			border: none;
		}
	}
	.collete-btn {
		width: 45px;
		height: 47px;
		text-align: center;
		padding-top: 5px;
		box-sizing: border-box;
		font-size: 12px;
		background: #fff;
		border: 1px solid $border;
		color: #bebebe;
		cursor: pointer;
		color: $theme-color;
		.icon {
			display: block;
			margin-bottom: 4px;
		}
		&:hover {
			color: $theme-color;
		}
	}
}
.b {
	padding: 20px 0;
	border-top: 1px solid $border;
	.tabs {
		display: flex;
		justify-content: center;
		margin-bottom: 30px;
		.tab {
			font-size: 16px;
			padding: 0px 15px;
			cursor: pointer;
			&:not(:last-of-type) {
				border-right: 1px solid $border;
			}
			&.active,
			&:hover {
				color: $theme-color;
			}
		}
	}
	.shop-info-wrap {
		border: 1px solid $border;
		padding: 20px;
		.params-wrap {
			padding: 15px 0;
			// border-bottom: 1px solid $border;
			margin-bottom: 20px;
			h3 {
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 24px;
				color: #ff4949;
				padding-top: 25px;
				.sign {
					width: 20px;
					height: 35px;
					margin: 0 14px;
					margin-top: 10px;
					&.sign2 {
						transform: rotateY(180deg);
					}
				}
			}
			.params-content {
				padding-left: 20px;
				color: #757575;
				font-size: 12px;
				margin: 10px 0;
			}
		}
		#comment {
			padding: 15px 0;
			h3 {
				height: 30px;
				line-height: 30px;
				background: #f7f7f7;
				padding-left: 20px;
			}
			.no-comment {
				padding-left: 20px;
				height: 30px;
				line-height: 30px;
			}
		}
	}
}
.leaderboard {
	float: left;
	width: 21%;
	margin-right: 7px;
	.title {
		background-color: #eee;
		line-height: 40px;
		padding: 0 10px;
	}
	.board {
		border: 1px solid #dee2e9;
		background-color: #fff;
		.item:last-child {
			border: none;
		}
		.item {
			display: flex;
			justify-content: flex-start;
			border-bottom: 1px solid #dee2e9;
			padding: 10px;
			cursor: pointer;
			.number {
				background-color: #333;
				color: #fff;
				width: 20px;
				text-align: center;
				height: 20px;
				line-height: 20px;
			}
			.img {
				width: 80px;
				flex: 0 0 80px;
				height: 80px;
				// border: 1px solid #dee2e9;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			.info {
				width: 63%;
				margin-left: 5px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;
				.name {
					width: 100%;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					color: #666;
					font-size: 12px;
					line-height: 16px;
				}
				.price {
					color: #ff7159;
				}
				.sold {
					color: #666;
					font-size: 12px;
					.num {
						color: #ff7159;
					}
				}
			}
		}
	}
}

.shop-info-item ::v-deep p {
	line-height: 20px;
}
</style>

<style lang="scss">
.preview-box {
	img {
		height: 350px;
		object-fit: cover;
	}
}
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
	height: 100% !important;
}

#detail .video-j-js {
	display: initial ;
}

</style>
